// extracted by mini-css-extract-plugin
export default {"navGroup":"zC183mKX","navGroupTitle":"XGVkNIGv"};